import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { Action } from "shared/types/Action"
import { FeedbackType } from "shared/types/FeedbackType"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export function useFeedbackActions(
  onFeedbackTypeSelect: (feedbackType: FeedbackType) => void
) {
  const { t } = useTranslation()
  const feedbackActions: Action[] = useMemo(
    () => [
      {
        id: "feedback-critic",
        icon: IconName.COMMENT,
        label: t("Feedback.Kritik"),
        onClick: () => onFeedbackTypeSelect(FeedbackType.CRITIC)
      },
      {
        id: "feedback-error",
        icon: IconName.BUG,
        label: t("Feedback.Fehler"),
        onClick: () => onFeedbackTypeSelect(FeedbackType.ERROR)
      },
      {
        id: "feedback-question",
        icon: IconName.QUESTION,
        label: t("Feedback.Frage"),
        onClick: () => onFeedbackTypeSelect(FeedbackType.QUESTION)
      },
      {
        id: "feedback-idea",
        icon: IconName.LIGHT_BULB,
        label: t("Feedback.Idee"),
        onClick: () => onFeedbackTypeSelect(FeedbackType.IDEA)
      },
      {
        id: "feedback-praise",
        icon: IconName.MOOD_HAPPY,
        label: t("Feedback.Lob"),
        onClick: () => onFeedbackTypeSelect(FeedbackType.PRAISE)
      }
    ],
    [onFeedbackTypeSelect, t]
  )

  return feedbackActions
}
